import React from 'react';
import { FormattedMessage } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import { List, ListItem } from '@material-ui/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing(3),
    flexWrap: 'wrap',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },
  divider: {
    borderTop: `1px solid ${theme.palette.divider}`
  },
  title: {
    fontSize: theme.typography.fontSize,
    color: theme.palette.text.secondary,
    fontWeight: theme.typography.fontWeightBold
  },
  description: {
    fontSize: theme.typography.fontSize,
    color: theme.palette.text.secondary,
    fontWeight: theme.typography.fontWeightRegular
  }
}));

const title = <FormattedMessage id="skillInfoCard.companySkills" />;

const CompanySkillTitle = ({ className }) => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.divider} />
      <div className={classNames(classes.titleContainer, className)}>
        <List className={classes.title} disablePadding>
          <ListItem className={classes.title} disableGutters>
            {title}
          </ListItem>
          <ListItem className={classes.description} disableGutters>
            <FormattedMessage id="skillInfoCard.companySkillsDescription" />
          </ListItem>
        </List>
      </div>
    </>
  );
};

CompanySkillTitle.propTypes = {
  className: PropTypes.string
};

export default CompanySkillTitle;
